function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopPos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11.67,
    viewBox: "0 0 12 11.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178014"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29503",
    d: "M.923 2.769A.923.923 0 0 1 0 1.846V.923A.923.923 0 0 1 .923 0h10.154A.923.923 0 0 1 12 .923v.923a.923.923 0 0 1-.923.923H.923z",
    transform: "rotate(-180 6 5.835)",
    style: {
      fill: "#66676b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29504",
    d: "M5.518 5.268a.45.45 0 0 1-.636-.636L6.364 3.15H.45a.45.45 0 0 1 0-.9h5.914L4.882.768a.45.45 0 0 1 .636-.636l2.25 2.25a.45.45 0 0 1 0 .636z",
    transform: "rotate(90 4.35 4.35)",
    style: {
      fill: "#66676b",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPos);
export default __webpack_public_path__ + "static/media/topPos.d1609218eacd4e567a9823336695ee80.svg";
export { ForwardRef as ReactComponent };